import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        width: {
            type: [Number, String],
            default: null,
        },
        widthSm: {
            type: [Number, String],
            default: null,
        },
        widthMd: {
            type: [Number, String],
            default: null,
        },
        widthLg: {
            type: [Number, String],
            default: null,
        },
        widthXl: {
            type: [Number, String],
            default: null,
        },
        widthXxl: {
            type: [Number, String],
            default: null,
        },
        widthHd: {
            type: [Number, String],
            default: null,
        },
        align: {
            type: String,
            default: null,
        },
        equal: {
            type: [Boolean, String],
            default: false,
        },
        index: {
            type: [Number, String],
            default: null,
        },
    },
    computed: {
        classMap() {
            return [
                this.width ? `col-${this.width}` : 'col-12',
                this.equal
                    ? typeof this.equal === 'boolean'
                        ? 'col'
                        : `col-${this.equal}`
                    : null,
                this.widthSm ? `col-sm-${this.widthSm}` : null,
                this.widthMd ? `col-md-${this.widthMd}` : null,
                this.widthLg ? `col-lg-${this.widthLg}` : null,
                this.widthXl ? `col-xl-${this.widthXl}` : null,
                this.widthXxl ? `col-xxl-${this.widthXxl}` : null,
                this.widthHd ? `col-hd-${this.widthHd}` : null,
                this.align == 'right' ? 'ml-auto' : null,
                this.align == 'left' ? 'mr-auto' : null,
            ];
        },
    },
});
